import { render, staticRenderFns } from "./edit-company-modal.vue?vue&type=template&id=16e45220&scoped=true&"
import script from "./edit-company-modal.vue?vue&type=script&lang=js&"
export * from "./edit-company-modal.vue?vue&type=script&lang=js&"
import style0 from "./edit-company-modal.vue?vue&type=style&index=0&id=16e45220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e45220",
  null
  
)

export default component.exports